import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Dictionery } from '../../Data/Dictionery';
const Styles = styled.div`
  background: linear-gradient(to bottom,var(--prime-1) 00%, #ffffff00 100%);
  .column-center {
    display: flex;
    flex-direction: column;
    margin: auto;
    min-height: 90lvh;
    max-width: 500px;
    padding: 0 1rem;
    height: 100%;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    .title {
      font-size: 4rem;
      font-weight: 700;
    }
    .text {
      font-size: 1.5rem;
      font-weight: 700;
    }
    .link {
      margin: 1rem 0;
      padding: 1rem 2rem;
      text-decoration: none;
      color: inherit;
      border: 1px solid var(--prime-1);
      border-radius: 100px;
      transition: var(--trans-1);
      font-weight: 700;
      &:hover {
        color: var(--n-grey-0);
        background-color: var(--prime-1);
        box-shadow: 0px 4px 50px -16px #00000028;
      }
    }
  }
`
export default function ErrorPage13 (props){
  const {data: dataRaw, lan} = props;
  const data = JSON.parse(dataRaw);
  return (
    <Styles>
      <div className='column-center'>
        <div className='title'>
          404
        </div>
        <div className='text'>
          {Dictionery.notFoundText[lan.filename]}
        </div>
        <Link to={"/" + lan.filename + "/"} className='link'>
          {Dictionery.notFoundLink[lan.filename]}
        </Link>
      </div>
    </Styles>
  )
}

